import { RouterProvider } from "react-router-dom";
import { mobileRouter } from "./mobile";

export {
  RequireAuth,
  RequireStep,
  selectCompletedSteps,
  selectCurrentPatientId,
  selectIsAuthenticated,
} from "./guards";

export const AppRouter = () => {
  return <RouterProvider router={mobileRouter} />;
};
